export default "__VITE_PUBLIC_ASSET__ba57b8e1__"